import { useContext } from "react";
import User from "../user/User"
import "./Header.css"
import { AuthContext } from "../../utils/AuthContext";

export default function Header ({ nickname }) {

    const { authState } = useContext(AuthContext);

    return <header>
        <div className="full-width header">
            <h1>OPTCG Binder</h1>
            {authState && <User nickname={nickname}/>}
        </div>
    </header>
}